import * as Yup from 'yup';

export const validationSchema = Yup.object().shape({
  full_name: Yup.string()
    .trim()
    .required('msg_error_required_field')
    .matches(/^'?\p{L}+(?:[' ]\p{L}+)*'?$/u, 'msg_error_invalid_name_format'),
  email: Yup.string().email('msg_error_invalid_email_format').required('msg_error_required_field'),
});
